import moment from "moment";

moment.locale('fr');

const sleep = (milliseconds) => {
    return new Promise(resolve => setTimeout(resolve, milliseconds))
};

const range = (start, stop, step=1) => {
    return new Array(Math.abs(stop-start)).fill(start).map((n,i)=>n+step*i);
};

const zeroPad = (num, places) => String(num).padStart(places, '0');

function intersect(a, b) {
    const setA = new Set(a);
    const setB = new Set(b);
    const intersection = new Set([...setA].filter(x => setB.has(x)));
    return Array.from(intersection);
}

function haveCommonElements(a, b){
    const intersection = intersect(a, b);
    return intersection.length !== 0;
}

function deepCopy(obj){
    return JSON.parse(JSON.stringify(obj));
}

export {sleep, moment, range, zeroPad, haveCommonElements, deepCopy};
